import React, { useContext } from "react";
import { IMAGES } from "../../assets";
import { useLocation, useNavigate } from "react-router-dom";
import BookCard from "../../components/book/BookCard";
import { AuthContext } from "../../context";

const OtherBooks = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const otheBookItem = location?.state?.otheBookItem;
  const title = location?.state?.title ?? "";
  const { activeLanguage } = useContext(AuthContext);
  return (
    <div>
      <div className="my-4 flex items-center justify-between">
        <button
          className="w-8 h-8 text-lg font-bold border-slate-400 border flex items-center justify-center rounded-full"
          onClick={() => navigate(-1)}
        >
          <img
            className="w-full h-full"
            alt="backarrow"
            src={IMAGES?.backIcon}
          />
        </button>
        <h2 className="mx-auto text-lg font-bold">{title}</h2>
      </div>

      <div className="grid lg:grid-cols-4 md:grid-cols-4 sm:grid-cols-2 grid-cols-2 lg:gap-4 md:gap-4 sm:gap-2 gap-2">
        {otheBookItem?.map((item) => {
          return (
            <BookCard
              key={item?._id}
              onClick={() =>
                navigate(`/aboutbook/${item?._id ?? item?.eBookData?._id}`, {
                  state: { item: item },
                })
              }
              img={item?.bookImage ?? IMAGES?.richDadPoorIcon}
              name={item?.bookName}
              price={
                activeLanguage === "Marathi"
                  ? "₹ " +
                    new Intl.NumberFormat("mr", {
                      maximumSignificantDigits: 2,
                    }).format(item.price)
                  : "₹ " + item.price
              }
              rating={item?.overallRating}
              link={`/otherbooks/The_Psycholology_of_Money`}
              type="vertical"
            />
          );
        })}
      </div>
    </div>
  );
};

export default OtherBooks;
